import fetch from 'isomorphic-fetch';
import { push } from 'react-router-redux'
import { toastr } from 'react-redux-toastr';

import { createReducer, responseOkay } from '../utils';
import { hideAuthDialogs, hideForgotten } from './modals';
import { receiveToken } from './auth';
import Payment from 'payment';
import { initialize } from 'react-ga';

const FETCH = 'bamboo-developments/user/FETCH';
const RESET = 'bamboo-developments/user/RESET';
const CREATE = 'bamboo-developments/user/CREATE';
const UPDATE = 'bamboo-developments/user/UPDATE';
const REGISTER = 'bamboo-developments/user/REGISTER';
const FORGOTTEN = 'bamboo-developments/user/FORGOTTEN';
const VERIFY_IDENTITY = 'bamboo-development/user/VERIFY_IDENTITY';
const RESEND_VERIFICATION = 'bamboo-development/user/RESEND_VERIFICATION';
const CREATE_PAYMENT_TOKEN = 'bamboo-developments/user/CREATE_PAYMENT_TOKEN';
const CREATE_PAYMENT = 'bamboo-developments/user/CREATE_PAYMENT';
const REMOVE_PAYMENT = 'bamboo-developments/user/REMOVE_PAYMENT';
const FETCH_SUCCESS = 'bamboo-developments/user/FETCH_SUCCESS';
const FETCH_ERROR = 'bamboo-developments/user/FETCH_ERROR';
const CREATE_PAYMENT_SUCCESS = 'bamboo-developments/user/CREATE_PAYMENT_SUCCESS';
const CREATE_PAYMENT_ERROR = 'bamboo-developments/user/CREATE_PAYMENT_ERROR';
const REMOVE_PAYMENT_SUCCESS = 'bamboo-developments/user/REMOVE_PAYMENT_SUCCESS';
const REMOVE_PAYMENT_ERROR = 'bamboo-developments/user/REMOVE_PAYMENT_ERROR';

const initialState = {
  data: null,
  fetching: false,
  isError: false,
  error: null,
};

export function resetUser() {
  return (dispatch) => {
    dispatch({ type: RESET });
  }
}

export function fetchUser(token) {
  return (dispatch) => {
    dispatch({ type: FETCH });

    const options = {
      method: 'GET',
      headers: {},
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
     }

    return fetch('/api/user', options)
      .then(responseOkay)
      .then(response => response.json())
      .then(payload => dispatch({ type: FETCH_SUCCESS, payload }))
      .catch(error => dispatch({ type: FETCH_ERROR }))
  };
};

export function createUser({email, name, phone, password, marketNew, marketInfo }) {
  return (dispatch) => {
    dispatch({ type: CREATE });

    const options = { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        organisation: process.env.REACT_APP_ORGANISATION,
        email,
        name,
        phone,
        password,
        marketNew,
        marketInfo,
      })
    };

    return fetch('/api/user', options)
    .then((response) => {
        if (response.status >= 200 && response.status < 400) {
          return response;
        }

        if (response.status === 409) {
          throw 'User already exists'
        } else if (response.status === 406) {
          throw 'Password should be at least 8 characters long'
        } else {
          throw response.statusText;
        }
      })
      .then(response => response.json())
      .then(payload => {
        dispatch(hideAuthDialogs());
        
        toastr.light('Created', 'Please check your email', {
          icon: 'success',
          status: 'success',
        });

        const {
          user,
          token } = payload;

        dispatch(receiveToken(token));
        dispatch({
          type: FETCH_SUCCESS,
          payload: user,
        });
      })
      .catch(error => dispatch({
        type: FETCH_ERROR,
        payload: error
      }));
  };
}

export function updateUser(token, { name, phone, password = '', solicitor = null }) {
  return (dispatch) => {
    dispatch({ type: UPDATE });

    const toUpdate = {
      name,
      phone,
    };

    if (!!password.length) {
      toUpdate.password = password;
    }

    if (!!solicitor) {
      toUpdate.solicitor = solicitor;
    }

    const options = { 
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toUpdate)
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
     }

    return fetch('/api/user', options)
      .then(responseOkay)
      .then(response => response.json())
      .then(payload => {
        toastr.light('Saved', 'User Details', {
          icon: 'success',
          status: 'success',
        });
        dispatch({
          type: FETCH_SUCCESS,
          payload
        });
      })
      .catch(error => dispatch({
        type: FETCH_ERROR,
        payload: error
      }));
  };
}

export function registerUser(key) {
  return (dispatch) => {
    dispatch({ type: REGISTER });

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ key }),
    };

    return fetch('/api/user/register', options)
      .then(responseOkay)
      .then(response => response.json())
      .then(payload => {
        const {
          user,
          token } = payload;

        dispatch(receiveToken(token));
        dispatch(push('/profile'));
        toastr.light('Registered', 'We have registered your email', {
          icon: 'success',
          status: 'success',
        });
        dispatch({
          type: FETCH_SUCCESS,
          payload: user,
        });
      })
      .catch(error => dispatch({
        type: FETCH_ERROR,
        payload: error
      }))
  }
}

export function forgottenUser(email) {
  return (dispatch) => {
    dispatch({ type: FORGOTTEN });

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    };

    return fetch('/api/user/forgotten', options)
      .then(responseOkay)
      .catch(() => {})
      .then(() => {
        dispatch(hideForgotten());
        toastr.light('Password reset sent', '', {
          icon: 'success',
          status: 'success',
        });
      })
  }
}

export function resendVerification(token) {
  return (dispatch) => {
    dispatch({ type: RESEND_VERIFICATION });

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch('/api/user/resendVerification', options)
      .then(() => toastr.light('Verification', 'We have sent you a verification email', {
        icon: 'success',
        status: 'success',
      }))
      .catch(() => {})
  }
}

export function verifyIdentity(token, identity) {
  return (dispatch) => {
    dispatch({ type: VERIFY_IDENTITY });

    toastr.light('Your Identity', 'Is being verified', {
      icon: 'info',
      status: 'info',
    });

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(identity),
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch('/api/user/verify', options)
      .then(response => response.json())
      .then((payload) => {
        toastr.light('Your Identity', 'Has been verified', {
          icon: 'success',
          status: 'success',
        });
        dispatch({
          type: FETCH_SUCCESS,
          payload,
        });
      })
      .catch(error => dispatch({
        type: FETCH_ERROR,
        payload: error
      }));
  }
}

const createToken =  
    (stripe, target) => 
      new Promise((resolve, reject) => {
        if (!stripe) {
          return reject();
        }
        stripe.card.createToken(target, (status, response) => {
          if (response.error) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });

const createStripeToken = (stripe, payload) =>
  createToken(stripe, payload)
    .then(tokenResponse => ({
      name: tokenResponse.card.name,
      token: tokenResponse.id,
      last4Digits: tokenResponse.card.last4,
    }))
    .catch((error) => {
      console.error(error.message); // We can show the error message from Stripe (userful to user)
      throw error;
    });

export function createPayment(token, { name, number, expiry, cvc }) {
  return (dispatch) => {
    dispatch({ type: CREATE_PAYMENT_TOKEN });

    if (name.length && number.length && expiry.length && cvc.length) {
      const [month, year] = expiry.replace(/\s/g, '').split('/');

      const payload = {
        cvc,
        exp_month: month,
        exp_year: year,
        name,
        number: number.replace(/\s/g, ''),
      };

      if (window.Stripe) {
        window.Stripe.setPublishableKey(process.env.REACT_APP_STRIPE_KEY);
      }

      return createStripeToken(window.Stripe, payload)
        .then((details) => {
          dispatch({ type: CREATE_PAYMENT });
          const brand = Payment.fns.cardType(number);

          const toSave = { 
              ...details, 
              brand
            };

          const options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(toSave),
            };
          
          if (token) {
            options.headers['Authorization'] = `Bearer ${token}`;
          }

          return Promise.all([
            fetch('/api/user/addPayment', options).then(responseOkay),
            toSave,
          ]);
        })
        .then(([response, details]) =>
          dispatch({
            type: CREATE_PAYMENT_SUCCESS,
            payload: details,
          })
        )
        .catch(error => dispatch({
          type: CREATE_PAYMENT_ERROR,
          payload: error
        }));
    } else {
      dispatch({ type: CREATE_PAYMENT_ERROR });
    }
  }
};

export function removePayment(token) {
  return (dispatch) => {
    dispatch({ type: REMOVE_PAYMENT });

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch('/api/user/removePayment', options)
      .then(responseOkay)
      .then(() => dispatch({
        type: REMOVE_PAYMENT_SUCCESS,
      }))
      .catch(error => dispatch({
        type: REMOVE_PAYMENT_ERROR,
        payload: error
      }));
  }
};

export default createReducer(initialState, {
  [FETCH]: state => ({
    ...state,
    fetching: true,
    isError: false,
    error: null,
  }),
  [RESET]: () => initialState,
  [FETCH_SUCCESS]: (state, payload) => ({
    ...state,
    data: payload,
    fetching: false,
    isError: false,
    error: null,
  }),
  [FETCH_ERROR]: (state, payload) => ({
    ...state,
    fetching: false,
    isError: true,
    error: payload,
  }),
  [CREATE_PAYMENT_SUCCESS]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      card: payload,
    },
  }),
  [REMOVE_PAYMENT_SUCCESS]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      card: null,
    },
  }),
});



// WEBPACK FOOTER //
// ./src/redux/user.js